<template>
    <section class="product-hero" :style="{ backgroundImage: 'url(\'' + bg + '\')' }">
        <div class="hero-overlay"></div>
        <span class="hero-label"><span class="colored">Steri</span>Spine<sup>TM</sup> <span v-html="code"></span></span>
        <h1 class="hero-title" v-html="title"></h1>
        <scroll-down></scroll-down>
    </section>
</template>

<script>
import ScrollDown from "./ScrollDown.vue";

export default {
    name : "ProductHero",
    components : { ScrollDown },
    props : ["bg", "code", "title"]
}
</script>

<style scoped lang="scss">
.product-hero {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 90vh;
    padding-top: 80px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
}

.hero-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.25);
}

.hero-label {
    position: relative;
    z-index: 1;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 15px;
    font-weight: 500;
}

.hero-label sup {
    font-size: 9px;
}

.hero-title {
    position: relative;
    z-index: 1;
    color: #fff;
    font-weight: 300;
    font-size: 42px;
    line-height: 1.3em;
    margin: 20px 0 0 0;
    padding: 0 20px;
}

@media screen and (max-width:768px) {
    .product-hero {
        min-height: 70vh;
        padding-top: 60px;
    }

    .hero-title {
        font-size: 28px;
    }
}
</style>
